import { Directive, inject, OnDestroy, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

export type ArticleSeoMetadata = {
  pageTitle: string;
  description: string;
};

@Directive()
export abstract class ArticleSeoComponent implements OnInit, OnDestroy {
  protected abstract readonly seo: ArticleSeoMetadata;

  private readonly title = inject(Title);
  private readonly meta = inject(Meta);

  ngOnInit(): void {
    this.title.setTitle(this.seo.pageTitle);
    this.meta.updateTag({ name: 'description', content: this.seo.description });
  }

  ngOnDestroy(): void {
    this.meta.removeTag("name='description'");
  }
}
